require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-glennsl-vrroom.json") })
        }
      }, "path---package-unpublished-glennsl-vrroom");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-glennsl-vrroom!./.cache/json/package-unpublished-glennsl-vrroom.json
// module id = 947
// module chunks = 231608221292675